import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconSocialMediaLinkedin.module.css';

const IconSocialMediaLinkedin = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 1000 1000">
      <path d="M937.9 10H62.1C33.3 10 10 33.3 10 62.1v875.7c0 28.8 23.3 52.1 52.1 52.1h875.7c28.8 0 52.1-23.3 52.1-52.1V62.1c.1-28.8-23.2-52.1-52-52.1zM285.4 887.8H124.3V369.7h161l.1 518.1zm-80.5-588.9c-51.6 0-93.4-41.8-93.4-93.4 0-51.5 41.8-93.3 93.4-93.3 51.5 0 93.3 41.8 93.3 93.3 0 51.6-41.8 93.4-93.3 93.4zm683.6 588.9H727.6v-252c0-60.1-1.1-137.4-83.7-137.4-83.8 0-96.6 65.4-96.6 133v256.3H386.4v-518h154.5v70.8h2.2c21.5-40.7 74-83.7 152.4-83.7 163.1 0 193.2 107.3 193.2 246.8v284.2h-.2z"></path>
    </svg>
  );
};

IconSocialMediaLinkedin.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

IconSocialMediaLinkedin.propTypes = { rootClassName: string, className: string };

export default IconSocialMediaLinkedin;
